// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Card-Title-module--cls1--CFliC","cls2":"Card-Title-module--cls2--2s12o Card-Title-module--cls1--CFliC"};